import FormRow from "../formRow/FormRow";
import CustomSelectInput from "../CustomSelectInput";

import { FC, useCallback, useEffect, useState } from "react";
import { Field, getIn, useFormikContext } from "formik";
import { DropdownInputGroup, TranslationKey } from "../../../types/modulesInterfaces";
import { useAppSelector, useCustomTranslation, useInputNameHandler } from "../../../app/hooks";
import { selectIsFetchingData } from "../../../app/features/builder/builderSlice";
import { translate } from "../../../utils/helperFunctions";
import { InteractiveCommentIcon } from "./StartWithWithoutGroup";

const Dropdown: FC<DropdownInputGroup> = ({
	inputName,
	dropdownOptions,
	disabled,
	label,
	index,
	comment,
	help,
	autosubmit,
	translateOptions,
	onChange,
	isMulti = false,
	handleLoadMore
}) => {
	const { name } = useInputNameHandler({ inputName, index })
	const [threadId, setThreadId] = useState<number | null>(null);
	const isFetchingData: boolean = useAppSelector(selectIsFetchingData);
	const { errors, touched, values } = useFormikContext();
	const translatedLabel = useCustomTranslation(label);

	useEffect(() => {
		if (!name || !values) return;
		setThreadId(getIn(values, `${name}_thread`));
	}, [name, values]);

	const getTranslatedLandUse = useCallback(() => {
		if (typeof dropdownOptions === "function" || !translateOptions) {
			return
		}
		const translatedOptions = dropdownOptions.map((option) => {
			return {
				...option,
				name: translate(option.name as TranslationKey),
			};
		})

		return translatedOptions
	}, [dropdownOptions, translateOptions]);

	return (
		<div style={{ display: "flex", justifyContent: "space-between" }}>
			<div style={{ width: "100%" }}>
				<FormRow
					rowComment={comment}
					rowHelp={help}
					isFetching={isFetchingData}
					error={
						getIn(errors, name) && getIn(touched, name)
							? getIn(errors, name)
							: undefined
					}
				>
					<Field
						label={translatedLabel}
						name={name}
						id={name}
						component={CustomSelectInput}
						options={translateOptions ? getTranslatedLandUse() : dropdownOptions}
						disabled={disabled}
						autosubmit={autosubmit}
						onChange={onChange}
						isMulti={isMulti}
						handleLoadMore={handleLoadMore}
					/>
				</FormRow>
			</div>
			{!isFetchingData && threadId && (
				<div
					style={{
						width: "10%",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<InteractiveCommentIcon threadId={threadId} />
				</div>
			)}
		</div>
	);
};

export default Dropdown;
